import { Component, Style } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import { FeatureRefs } from '../cssFeatures.types'
import { mapValues } from '../../utils/mapValues'

export const viewportSize = createCssCompNode('styleBased', 'viewportSize', {
	getDependencies: (component: Component, refs: FeatureRefs<'styleBased'>) =>
		component.componentType === 'WRichText' ? refs.compStyles(component) : null,
	toViewItem: (__, compStyles) => {
		if (compStyles?.type !== 'variants') {
			return null
		}

		return mapValues(
			compStyles.css,
			(variants, breakpointId) => breakpointId !== 'default' && Object.values(variants).some(isTextScaled)
		)
	},
})

const isTextScaled = (style: Style) => {
	const properties = style?.style?.properties
	if (!properties) {
		return false
	}
	return properties.textScale__maxFontSize && properties.textScale__minFontSize
}
